"use client";

import React from "react";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const GGSCards = ({ key, cards }) => {
  return (
    <>
      <div className="grid-container tps-layout-wrapper">
        <div className="grid-x grid-margin-x">
          <div className="cell tps-layout">
            <div className="ggs-cta-wrapper" id="feature-callouts">
              <div className="grid-x grid-margin-x">
                {cards.map((card, index) => (
                  <div
                    key={`ggs-card${index}`}
                    className="cell small-12 tablet-4 grid-x"
                  >
                    <a
                      className="ggs-cta-item grid-x"
                      href={card.ButtonLink}
                      title={card.ButtonLabel}
                    >
                      <p className="ggs-cta-item-title">{card.Title}</p>
                      <div className="ggs-cta-image-wrapper">
                        <Image
                          className="ggs-cta-item-image"
                          alt={card.Title}
                          aria-hidden="true"
                          src={getImageURL(card.Image?.data?.attributes.url)}
                          width={card.Image?.data?.attributes.width || 400}
                          height={card.Image?.data?.attributes.height || 300}
                        />
                        <p className="ggs-cta-image-title-wrapper">
                          <span className="ggs-cta-image-title">
                            {card.ImageTitle}
                          </span>
                          {card.ImageSubtitle && (
                            <span className="ggs-cta-image-subtitle">
                              {card.ImageSubtitle}
                            </span>
                          )}
                        </p>
                      </div>
                      <div
                        className="ggs-cta-item-description"
                        dangerouslySetInnerHTML={{
                          __html: card?.Description,
                        }}
                      />
                      <div className="ggs-cta-item-button-wrapper">
                        <span className="ggs-cta-item-button button">
                          {card.ButtonLabel}
                        </span>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GGSCards;
